export default __webpack_public_path__ + "static/media/17.30406e31.jpg";